import Http from "./http";
import { The_Ability } from "../store/index";

export default {
  index(filter) {
    return Http.get(`/ai_request_sessions`, {
      params: {
        // solution_id: localStorage.getItem("solution_id"),
        ...filter,
      },
    });
  },

  indexKanban(filter) {
    // let search = ''
    const {limit, page, level, ...f} = filter
    // search = `_page=${page}&_limit=${limit || 1000}&attributes.level=${level}`

    return Http.get(`/ai_request_sessions`, {
      params: {
        solution_id: localStorage.getItem("solution_id"),
        limit, 
        page, 
        status: level,
        ...f,
      }
    })
  },

  show(id) {
    return Http.get(`/ai_request_sessions/${id}`);
  },
};
